<div class="fcp-form-field-label fcp-text-body-s">
    <ng-content select="label[fcpFieldLabel]"></ng-content>
</div>
<div
    class="fcp-form-field fcp-text-body-m"
    [ngClass]="{
        'fcp-form-field--fluid': width === 'fluid',
        'fcp-form-field-default-height': height === 'default',
        'fcp-form-field--disabled': fcpInput?.nativeElement?.disabled || fcpSelect?.disabled,
        'fcp-form-field--invalid': isInvalid,
        'fcp-form-field--compact': compact
    }"
>
    <div class="fcp-form-field-prefix">
        <ng-content select="[fcpFieldPrefix]"></ng-content>
    </div>
    <div class="fcp-form-field-infix" [ngClass]="{ 'fcp-form-field-infix--fluid': width === 'fluid' }">
        <ng-content></ng-content>
    </div>
    <div class="fcp-form-field-suffix">
        <ng-content select="[fcpFieldSuffix]"></ng-content>
    </div>
</div>
<div
    class="fcp-form-field-error-message fcp-text-body-s"
    [ngClass]="{ 'fcp-form-field-error-message-inline': showErrorInline }"
    *ngIf="isInvalid"
>
    <fcp-error>
        <ng-content select="span[fcpFieldError]"></ng-content>
    </fcp-error>
</div>
<div class="fcp-form-field-hint fcp-text-body-s" *ngIf="!isInvalid">
    <ng-content select="span[fcpFieldHint]"></ng-content>
</div>
